import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RequestCancellationService {
  private pendingRequests = new Map<string, Subject<void>>();

  /**
   * Erstellt einen eindeutigen Schlüssel für eine HTTP-Anfrage
   */
  private createRequestKey(method: string, url: string, body?: any): string {
    const bodyHash = body ? JSON.stringify(body) : '';
    return `${method}:${url}:${bodyHash}`;
  }

  /**
   * Cancelt eine vorhandene Anfrage und registriert eine neue
   */
  cancelAndRegisterRequest(method: string, url: string, body?: any): Subject<void> {
    const requestKey = this.createRequestKey(method, url, body);

    // Vorhandene Anfrage canceln
    const existingRequest = this.pendingRequests.get(requestKey);
    if (existingRequest && !existingRequest.closed) {
      existingRequest.next();
      existingRequest.complete();
    }

    // Neue Cancellation Subject erstellen
    const cancellationSubject = new Subject<void>();
    this.pendingRequests.set(requestKey, cancellationSubject);

    return cancellationSubject;
  }

  /**
   * Entfernt eine Anfrage aus der Map wenn sie abgeschlossen ist
   */
  removeRequest(method: string, url: string, body?: any): void {
    const requestKey = this.createRequestKey(method, url, body);
    const request = this.pendingRequests.get(requestKey);
    if (request) {
      if (!request.closed) {
        request.complete();
      }
      this.pendingRequests.delete(requestKey);
    }
  }

  /**
   * Bereinigt alle ausstehenden Anfragen
   */
  clearAllRequests(): void {
    this.pendingRequests.forEach(subject => {
      if (!subject.closed) {
        subject.next();
        subject.complete();
      }
    });
    this.pendingRequests.clear();
  }

    /**
     * Cancelt eine vorhandene GET-Anfrage und registriert eine neue
     * Für andere HTTP-Methoden wird nur registriert, ohne zu canceln
     */
    cancelAndRegisterGetRequest(method: string, url: string, body?: any): Subject<void> {
        const requestKey = this.createRequestKey(method, url, body);

        // Nur bei GET-Requests vorhandene Anfrage canceln
        if (method.toUpperCase() === 'GET') {
            const existingRequest = this.pendingRequests.get(requestKey);
            if (existingRequest && !existingRequest.closed) {
                existingRequest.next();
                existingRequest.complete();
            }
        }

        // Neue Cancellation Subject erstellen
        const cancellationSubject = new Subject<void>();
        this.pendingRequests.set(requestKey, cancellationSubject);

        return cancellationSubject;
    }
}
